import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ClickableWrap from '../ClickableWrap';
import Icon from '../Icon';
import Button from '../Button';

import './styles.less';

const FeaturedContent = (props) => {
    const { variant, isReversed, title, icon, tag, url, mediaContent, content, contentId, buttons } = props;

    const renderBody = () => {
        return (
            <div className="p-featured-content__body">
                {tag ? <div className="p-featured-content__tag u-text-h6">{tag}</div> : null}
                <ClickableWrap url={url}>
                    {title ? (
                        <div className="u-text-h4 u-text-flow">
                            {icon ? <Icon {...icon} /> : null}
                            {title}
                        </div>
                    ) : null}
                </ClickableWrap>
                <div className="p-featured-content__text">{content}</div>
                {buttons ? (
                    <div className="p-featured-content__buttons">
                        {buttons.map((btn, i) => {
                            const key = i;
                            return <Button {...btn} key={key} />;
                        })}
                    </div>
                ) : null}
            </div>
        );
    };

    const renderMedia = () => {
        return (
            <div className="p-featured-content__media">
                <ClickableWrap url={url}>{mediaContent}</ClickableWrap>
            </div>
        );
    };

    return (
        <div
            className={classNames({
                'p-featured-content': true,
                [`p-featured-content--${variant}`]: true,
                'p-featured-content--reversed': isReversed
            })}
            data-content-id={contentId}
        >
            {renderMedia()}
            {renderBody()}
        </div>
    );
};

FeaturedContent.propTypes = {
    variant: PropTypes.oneOf(['default', 'vertical', 'masked', 'circle', 'promoted']),
    isReversed: PropTypes.bool,
    title: PropTypes.string,
    icon: PropTypes.shape(Icon.propTypes),
    tag: PropTypes.string,
    url: PropTypes.string,
    mediaContent: PropTypes.node,
    content: PropTypes.node,
    contentId: PropTypes.string,
    buttons: PropTypes.arrayOf(PropTypes.shape(Button.propTypes))
};

FeaturedContent.defaultProps = {
    variant: 'default',
    isReversed: false,
    title: undefined,
    icon: undefined,
    tag: undefined,
    url: undefined,
    mediaContent: null,
    content: null,
    contentId: undefined,
    buttons: undefined
};

export default FeaturedContent;
